// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://src/main.css"],"names":[],"mappings":";AACA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd","sourcesContent":["\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
